module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_MURS_METRO_DIAMANTO_MAT_TORBA_VERTICALE.ddeecb96.webp";